import React from 'react';

const CommonBlockShimmer = () =>
{
	return (
		<div className='row cab-row style-scope animated_skelton-animate'>
			<div className='left cab-icon label style-scope animated_skelton-animate'>
				<div className='icon-placeholder shimmer style-scope animated_skelton-animate' />
			</div>
			<div className='middle holder style-scope animated_skelton-animate'>
				<div className='text-placeholder title shimmer style-scope animated_skelton-animate' />
				<div className='text-placeholder shimmer style-scope animated_skelton-animate' />
			</div>
			<div className='far-right title shimmer style-scope animated_skelton-animate'>
				<div className='text-placeholder shimmer style-scope animated_skelton-animate' />
			</div>
		</div>
	);
};

export default CommonBlockShimmer;